import { useEffect, useState } from 'react';
import { Search, Loader2, FolderOpen } from 'lucide-react';
import apiService from '../../services/apiService';
import { formatarMoeda, formatarData, formatarDataHora, REGIMES } from './formato';

/** Lista das precificações salvas; "Abrir" recarrega a nota e o resultado na tela. */
export default function HistoricoPrecificacao({ onAbrir }) {
  const [busca, setBusca] = useState('');
  const [lista, setLista] = useState([]);
  const [carregando, setCarregando] = useState(false);
  const [erro, setErro] = useState('');

  async function carregar(termo) {
    setCarregando(true);
    setErro('');
    try {
      const resp = await apiService.precificacao.historico({ busca: termo, limite: 100 });
      setLista(resp.data.data || []);
    } catch (error) {
      console.error('❌ Erro ao carregar histórico de precificação:', error);
      setErro('Não foi possível carregar o histórico.');
    } finally {
      setCarregando(false);
    }
  }

  useEffect(() => {
    carregar('');
  }, []);

  return (
    <div className="bg-white border border-gray-200 rounded-xl p-5 space-y-3">
      <form
        onSubmit={e => { e.preventDefault(); carregar(busca); }}
        className="flex gap-2"
      >
        <div className="relative flex-1">
          <Search className="w-4 h-4 text-gray-400 absolute left-3 top-1/2 -translate-y-1/2" />
          <input
            value={busca}
            onChange={e => setBusca(e.target.value)}
            placeholder="Buscar por número da nota, fornecedor ou chave"
            className="w-full pl-9 pr-3 py-2 text-sm border border-gray-300 rounded-lg"
          />
        </div>
        <button type="submit" className="px-4 py-2 text-sm bg-blue-600 text-white rounded-lg hover:bg-blue-700">Buscar</button>
      </form>

      {carregando && <p className="flex items-center gap-2 text-sm text-gray-500"><Loader2 className="w-4 h-4 animate-spin" />Carregando…</p>}
      {erro && <p className="text-sm text-red-600">{erro}</p>}
      {!carregando && !erro && lista.length === 0 && <p className="text-sm text-gray-500">Nenhuma precificação salva ainda.</p>}

      {lista.length > 0 && (
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="text-left text-xs text-gray-500 border-b">
                <th className="py-2 pr-3">Nota</th>
                <th className="py-2 pr-3">Fornecedor</th>
                <th className="py-2 pr-3">Loja / regime</th>
                <th className="py-2 pr-3 text-right">Valor nota</th>
                <th className="py-2 pr-3 text-right">Frete</th>
                <th className="py-2 pr-3 text-right">Custo total</th>
                <th className="py-2 pr-3">Salvo em</th>
                <th className="py-2" />
              </tr>
            </thead>
            <tbody>
              {lista.map(n => (
                <tr key={n.id} className="border-b border-gray-100 hover:bg-gray-50">
                  <td className="py-2 pr-3 whitespace-nowrap">{n.numero}/{n.serie}<br /><span className="text-xs text-gray-500">{formatarData(n.data_emissao)} · {n.total_itens} itens</span></td>
                  <td className="py-2 pr-3">{n.emitente_nome}<span className="text-xs text-gray-500"> ({n.emitente_uf})</span></td>
                  <td className="py-2 pr-3">{n.loja || '—'}<br /><span className="text-xs text-gray-500">{REGIMES.find(r => r.valor === n.regime)?.label}</span></td>
                  <td className="py-2 pr-3 text-right">{formatarMoeda(n.valor_nota)}</td>
                  <td className="py-2 pr-3 text-right">{formatarMoeda(n.frete_fob)}</td>
                  <td className="py-2 pr-3 text-right font-semibold">{formatarMoeda(n.custo_total_nota)}</td>
                  <td className="py-2 pr-3 whitespace-nowrap text-xs text-gray-600">{formatarDataHora(n.created_at)}<br />{n.usuario}</td>
                  <td className="py-2 text-right">
                    <button
                      type="button"
                      onClick={() => onAbrir(n.id)}
                      className="inline-flex items-center gap-1 px-3 py-1 text-xs border border-blue-300 text-blue-700 rounded-md hover:bg-blue-50"
                    >
                      <FolderOpen className="w-3.5 h-3.5" /> Abrir
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
